// src/conf.js

// https://api.afripods.com
// http://localhost:7777
const apiURL = process.env.AFRIPODS_API_URL
const appURL = process.env.AFRIPODS_APP_URL
const mediaURL = process.env.AFRIPODS_MEDIA_URL
const imgURL = 'https://afripods-data.s3.amazonaws.com'
const apiPayoutURL = process.env.AFRIPODS_PAYMENT_API_URL

export default {
  clarityProjectId: process.env.VUE_APP_CLARITY_PROJECT_ID || 'tmw6b0wjpo',
  url: {
    default: apiURL,
    app: appURL,
    media: mediaURL,
    networks: `${apiURL}/networks`,
    trendingNetworks: `${apiURL}/networks/explore`,
    stations: `${apiURL}/networks/stations`,
    podcasts: `${apiURL}/podcasts`,
    episodes: `${apiURL}/episodes`,
    episodes_harvested: `${apiURL}/harvested/search/episodes`,
    episodesByPodcast: `${apiURL}/episodes/findByPodcast`,
    ads: `${apiURL}/rolls`,
    categories: `${apiURL}/categories/all`,
    search: `${apiURL}/harvested/search`,
    login: `${apiURL}/auth`,
    login_as_user: `${apiURL}/auth/login_as_user`,
    password_recover: `${apiURL}/users/recover_password`,
    password_reset: `${apiURL}/users/reset_password`,
    user: `${apiURL}/user`,
    podcast_import_preview: `${apiURL}/import/podcast`,
    podcast_import: `${apiURL}/import/podcast`,
    listener_users: `${apiURL}/listener/users`,
    listener_dashboard: `${apiURL}/listener/dashboard`,
    podcaster_networks: `${apiURL}/podcaster/networks`,
    podcaster_stations: `${apiURL}/podcaster/networks/stations`,
    podcaster_podcasts: `${apiURL}/podcaster/podcasts`,
    podcaster_episodes: `${apiURL}/podcaster/episodes`,
    podcaster_users: `${apiURL}/podcaster/users`,
    podcaster_stats: `${apiURL}/podcaster/podcasts`,
    podcaster_recordings: `${apiURL}/podcaster/recordings`,
    podcaster_schedules: `${apiURL}/podcaster/schedules`,
    podcaster_streams: `${apiURL}/podcaster/stations`,
    advertiser_ads: `${apiURL}/advertiser/ads`,
    advertiser_scheduled_ads: `${apiURL}/advertiser/scheduledAds`,
    advertiser_users: `${apiURL}/advertiser/users`,
    admin_categories: `${apiURL}/admin/categories`,
    admin_podcasts: `${apiURL}/admin/podcasts`,
    admin_featured: `${apiURL}/admin/featured`,
    admin_highlighted: `${apiURL}/admin/podcasts/highlighted`,
    admin_episodes: `${apiURL}/admin/episodes`,
    admin_positions: `${apiURL}/admin/positions`,
    admin_users: `${apiURL}/admin/users`,
    admin_jobs: `${apiURL}/jobs`,
    admin_ads: `${apiURL}/admin/ads`,
    admin_schedule_ads: `${apiURL}/admin/scheduledAds`,
    admin_notifications: `${apiURL}/admin/notifications`,
    admin_stats_overview: `${apiURL}/admin/stats/overview`,
    admin_networks: `${apiURL}/admin/networks`,
    admin_stations: `${apiURL}/admin/networks/stations`,
    raw_stats_csv: `${apiURL}/admin/stats/raw_csv`,
    stats_csv: `${apiURL}/admin/stats/stats_csv`,
    stats_approvals: `${apiURL}/stats/approvals`,
    stats_categories: `${apiURL}/stats/categories`,
    stats_episodes: `${apiURL}/stats/episodes`,
    stats_podcasts: `${apiURL}/stats/podcasts`,
    stats_users: `${apiURL}/stats/users`,
    languages: `${apiURL}/languages`,
    locations: `${apiURL}/locations`,
    jobs: `${apiURL}/jobs`,
    africanLocations: `${apiURL}/locations/countries/african`,
    feed: `${apiURL}/feed`,
    storeToken: `${apiURL}/google/storeToken`,
    refreshToken: `${apiURL}/google/refreshToken`,
    authUrl: `${apiURL}/google/authUrl`,
    fetchRSS: `${apiURL}/import/podcast?rss=`,
    ghostPages: `${apiURL}/cms/pages`,
    ghostPage: `${apiURL}/cms/pages/slug`,
    ghostPosts: `${apiURL}/cms/posts`,
    ghostFeaturedPosts: `${apiURL}/cms/posts?filter=featured:true&limit=all`,
    ghostPost: `${apiURL}/cms/posts/slug`,
    ghostTags: `${apiURL}/cms/tags`,
    ghostSettings: `${apiURL}/cms/settings`,
    paymentRevenue: `${apiPayoutURL}/revenue`,
    paymentCountries: `${apiPayoutURL}/countries`,
    paymentPayout: `${apiPayoutURL}/payout`,
    paymentBanks: `${apiPayoutURL}/banks`,
  },
  upload: {
    image: `${apiURL}/creator_s3_image_upload`,
    audio: `${apiURL}/s3_audio_upload`,
    itunes: `${apiURL}/s3_itunes_image_upload`,
  },
  image: {
    user: {
      thumb: `${imgURL}/author/main_image/thumbnail/`,
      main: `${imgURL}/author/main_image/`,
      cover: `${imgURL}/author/cover_image/`,
    },
    network: {
      main: `${imgURL}/upload/network/main_image/`,
      cover: `${imgURL}/upload/network/cover_image/`,
    },
    station: {
      main: `${imgURL}/upload/station/main_image/`,
      cover: `${imgURL}/upload/station/cover_image/`,
    },
    podcast: {
      thumb: `${imgURL}/podcast/main_image/thumbnail/`,
      main: `${imgURL}/podcast/main_image/`,
      cover: `${imgURL}/podcast/cover_image/`,
    },
    episode: {
      thumb: `${imgURL}/episode/main_image/thumbnail/`,
      main: `${imgURL}/episode/main_image/`,
    },
    category: {
      thumb: `${imgURL}/category/main_image/thumbnail/`,
      main: `${imgURL}/category/main_image/`,
    },
    ad: {
      thumb: `${imgURL}/ad/main_image/thumbnail/`,
      main: `${imgURL}/ad/main_image/`,
    },
  },
}



// WEBPACK FOOTER //
// ./src/conf/index.js